import {
  CHANNEL_DETAILS_SCREEN,
  EDIT_CHANNEL_SCREEN,
  INVITE_SCREEN,
  MEMBER_LIST_SCREEN,
  VISIBILITY_AND_ENROLLMENT_SCREEN,
} from '../../Constants';
import { KitText, KitTouchable } from '@omni/kit/components';
import React, { useCallback } from 'react';

import ChannelDetailsScreen from './ChannelDetailsScreen';
import { ChannelType } from '../../redux/types';
import Colors from '@omni/kit/theming/Colors';
import EditChannelScreen from './EditChannelScreen';
import { GroupChannel } from '@sendbird/chat/groupChannel';
import InviteScreen from './InviteScreen';
import { LeftNavType } from '../../../mobile/components/LeftNavButton';
import MemberListScreen from './MemberListScreen';
import { Platform } from 'react-native';
import { channelSelector } from '../../redux/selectors';
import { createNativeStackNavigator } from 'react-native-screens/native-stack';
import { createStackNavigator } from '@react-navigation/stack';
import { getNavOptions } from '../../../mobile/navigation/AppNavigator';
import { useSelector } from 'react-redux';
import VisibilityAndEnrollmentScreen from './VisibilityAndEnrollmentScreen';
import { RootSiblingParent } from 'react-native-root-siblings';

const debug = require('debug')('tca:chat:screen:ChannelDetailStack');

// @ts-ignore
const Stack = Platform.select({
  default: createNativeStackNavigator(),
  web: createStackNavigator(),
});

export const ChannelDetailsStack = ({
  closeModal,
}: {
  closeModal?: () => void;
}) => {
  const channel = useSelector(channelSelector) as GroupChannel;

  const parseChannelData = useCallback(() => {
    try {
      const data = JSON.parse(channel.data);
      debug('channel data ', data);

      return data;
    } catch {
      debug('Could not parse channel data');
    }
  }, [channel]);

  return (
    <RootSiblingParent>
      <Stack.Navigator
        screenOptions={{
          // @ts-ignore
          headerHideShadow: true,
          headerStyle: {
            borderBottomWidth: 0,
            elevation: 0,
            shadowColor: 'transparent',
          },
          headerTopInsetEnabled: false, // react-native-screens (Android)
        }}
      >
        <Stack.Screen
          name={CHANNEL_DETAILS_SCREEN}
          component={ChannelDetailsScreen}
          options={({ route, navigation }) => ({
            ...getNavOptions(
              channel?.customType === ChannelType.Direct
                ? 'Conversation details'
                : 'Group details',
              { navigation },
              LeftNavType.Dismiss,
              closeModal
            ),
            headerRight: () =>
              channel?.customType !== ChannelType.Direct &&
              channel?.myRole === 'operator' ? (
                <KitTouchable
                  // @ts-ignore
                  onPress={() => {
                    navigation.navigate(EDIT_CHANNEL_SCREEN, {
                      channelData: parseChannelData(),
                    });
                  }}
                  style={{
                    paddingLeft: 12,
                    paddingRight: Platform.OS === 'ios' ? 12 : 18,
                    paddingVertical: 6,
                    marginRight: -6,
                    borderRadius: 40,
                  }}
                >
                  <KitText brandColor fontSize={17}>
                    Edit
                  </KitText>
                </KitTouchable>
              ) : null,
          })}
        />
        <Stack.Screen
          name={EDIT_CHANNEL_SCREEN}
          component={EditChannelScreen}
          options={(props) => ({
            ...getNavOptions('Edit group', props),
            headerRight: () => (
              <KitTouchable
                onPress={null}
                style={{
                  paddingLeft: 12,
                  paddingRight: Platform.OS === 'ios' ? 12 : 18,
                  paddingVertical: 6,
                  marginRight: -6,
                  borderRadius: 40,
                }}
              >
                <KitText color={Colors.N400} fontSize={17}>
                  Save
                </KitText>
              </KitTouchable>
            ),
          })}
        />
        <Stack.Screen
          name={VISIBILITY_AND_ENROLLMENT_SCREEN}
          component={VisibilityAndEnrollmentScreen}
          // @ts-ignore
          options={({ navigation, route }) => ({
            // @ts-ignore
            ...getNavOptions('Visibility and enrollment', { navigation }),
            headerRight: () => (
              <KitTouchable
                onPress={null}
                style={{
                  paddingLeft: 12,
                  paddingRight: Platform.OS === 'ios' ? 12 : 18,
                  paddingVertical: 6,
                  marginRight: -6,
                  borderRadius: 40,
                }}
              >
                <KitText color={Colors.N400} fontSize={17}>
                  Save
                </KitText>
              </KitTouchable>
            ),
          })}
        />
        <Stack.Screen
          name={MEMBER_LIST_SCREEN}
          component={MemberListScreen}
          // @ts-ignore
          options={({ navigation, route }) =>
            // @ts-ignore
            getNavOptions(route?.params?.title || 'Members', { navigation })
          }
        />
        <Stack.Screen
          name={INVITE_SCREEN}
          component={InviteScreen}
          options={(props) => getNavOptions('Add people', props)}
        />
      </Stack.Navigator>
    </RootSiblingParent>
  );
};
